import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { Button } from '../../../../../shared/model/enum';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SendDataService } from '../../../../../shared/services/send-data.service';
import { PartsListService } from '../../pages/parts-list/parts-list.service';

@Component({
  selector: 'app-view-consignment',
  templateUrl: './view-consignment.component.html',
  styleUrls: ['./view-consignment.component.scss']
})
export class ViewConsignmentComponent implements OnInit {
  enumButtonName = Button;
  title
 @Input() data:any ={}

 constructor(public activeModal: NgbActiveModal,public toaster: ToastrService,
     public renderer: Renderer2,
      public sendDataService: SendDataService,
       public partsListService: PartsListService,
       ) {}

  ngOnInit(): void {
    this.data = this.data??{}
    this.data = {
      ...this.data,
      viewConsignmentDetail:true,
      inventoryLineDetail: this.data.inventoryLineDetail ?? false,
    }
     this.getById()
  }
  getById(){
    if(!this.data.id)return
    switch(this.title){
      case 'Inventory Line Details':
        this.partsListService.getInventoryLineDetailsById(this.data?.id,this.data?.inventoryLineId).subscribe((res)=>{
          if(res?.isSuccess){
            this.data = {
              ...this.data,
              ...res?.response
            }
            this.partsListService.setInfoList(this.data)
          }
        })
      break;
      case 'Consignment Details':
        this.partsListService.getConsignmentDetailsById(this.data?.id,this.data?.inventoryLineId).subscribe((res)=>{
          if(res?.isSuccess){
            this.data = {
              ...this.data,
              ...res?.response
            }
            this.partsListService.setInfoList(this.data)
          }
        })
      break;
    }
  }
  
  onNextClick(label){
    }
}
